import React from 'react';
import { gaClick } from '../helpers/functions'
import { Link } from 'react-router';
import { DropdownButton, MenuItem } from 'react-bootstrap';
import config from "../config";

class Button extends React.Component {

    render() {
        let button;
        
        if (this.props.type === "see-all") {
            button = (
                <Link to={this.props.link}>
                    <div className="see-all" >{this.props.text} <i className="fa fa-chevron-right" aria-hidden="true"></i></div>
                </Link>
            )
        }
        else {
            button = (
                <DropdownButton className="button" title={this.props.text} id='dropdown-basic' >
                    {this.props.dropDownLinks.map((link, i) => <MenuItem href={link.link} key={i} target="_blank" onClick={gaClick.bind(this, link.retailer)}>{link.retailer}</MenuItem>)}
                </DropdownButton>
            )
        }
        return (
            <div className="button-container">
                {button}
            </div>
        )
    }
}

export default Button;


// WEBPACK FOOTER //
// ./src/components/Button.js